import React from 'react';
import { getCredentialingOverview } from 'api/credentialing';
import { ENPIType, TCredentialingOverview } from 'types/credentialing';

const INIT_DATA: TCredentialingOverview = {
    billingNpiType: null,
    providers: [],
    states: [],
};

const TEST_DATA: TCredentialingOverview = {
    billingNpiType: {
        id: 1,
        providerId: 1,
        recordType: 'practice_npi',
        value: ENPIType.PRACTICE_NPI,
        createAt: '2026-01-01',
        createBy: 1,
        updateAt: '2026-01-01',
        updateBy: 1,
    },
    providers: [
        {
            credentialingId: 1,
            email: 'test@test.com',
            firstName: 'Test',
            lastName: 'Test',
            onboardingStatus: 'INIT',
            onboardingStep: 'INIT',
            providerId: 1,
        },
        {
            credentialingId: 2,
            email: 'test2@test.com',
            firstName: 'Test2',
            lastName: 'Test2',
            onboardingStatus: 'INIT',
            onboardingStep: 'INIT',
            providerId: 2,
        },
    ],
    states: ['AK', 'CA'],
};

const useTestData = false;

let globalData: TCredentialingOverview = useTestData ? TEST_DATA : INIT_DATA;

const useCredentialInfo = (): [TCredentialingOverview, boolean, () => void] => {
    const [loading, setLoading] = React.useState(false);
    const [data, setData] = React.useState<TCredentialingOverview>(globalData);

    const fetchData = React.useCallback(async () => {
        setLoading(true);
        try {
            const result = await getCredentialingOverview();
            if (!result.error) {
                const overview: TCredentialingOverview = result?.data?.data || INIT_DATA;
                globalData = overview;
                setData(overview);
            }
        } catch (e) {
            console.error(e);
        } finally {
            setLoading(false);
        }
    }, []);

    React.useEffect(() => {
        if (useTestData) {
            return;
        }
        fetchData();
    }, [fetchData]);

    return [data, loading, fetchData];
};

export default useCredentialInfo;
